import { PublicApiClient } from '@guiker/authentication-shared'
import { useConfig } from '@guiker/config-context'
import { v4 as uuid } from '@guiker/uuid'

export const usePublicAuthenticationApiClient = () => {
  const { apiBaseUrl: baseUrl } = useConfig()
  return PublicApiClient({ baseUrl, correlatedRequestId: uuid() })
}
